// extracted by mini-css-extract-plugin
export var backupIcon = "_np-1";
export var image = "_np-0";